import React from "react";
import { Alert } from "antd";
import { useQuery } from "@tanstack/react-query";

import {
	HI_SERVICE_CHECKING_NOTICE,
	HI_SERVICE_MOCK_NOTICE,
	HI_SERVICE_STATUS_QUERY_KEY,
	HI_SERVICE_UNAVAILABLE_NOTICE,
	fetchHiServiceStatus,
} from "../../api/healthcare/hiServiceStatusApi";

type HiServiceNoticeState = "checking" | "mock" | "unavailable";

const NOTICE_COPY: Record<HiServiceNoticeState, string> = {
	checking: HI_SERVICE_CHECKING_NOTICE,
	mock: HI_SERVICE_MOCK_NOTICE,
	unavailable: HI_SERVICE_UNAVAILABLE_NOTICE,
};

interface HiServiceModeNoticeProps {
	/** CU-14ygtkj8z2z: tighter spacing for surfaces with limited vertical room. */
	compact?: boolean;
	/** CU-14ygtkj65rw: distinguishes a second instance, such as the print-only IHI summary's. */
	testId?: string;
}

// CU-14ygtkj8z2z: the mode comes only from healthcare's status endpoint, never the browser environment; not closable by design.
const HiServiceModeNotice: React.FC<HiServiceModeNoticeProps> = ({ compact = false, testId = "hi-service-mode-notice" }) => {
	const { data, isPending, isError } = useQuery({
		queryKey: HI_SERVICE_STATUS_QUERY_KEY,
		queryFn: fetchHiServiceStatus,
	});

	const state: HiServiceNoticeState = isPending ? "checking" : !isError && data?.mode === "mock" ? "mock" : "unavailable";

	return (
		<Alert
			type="warning"
			showIcon
			message={NOTICE_COPY[state]}
			data-testid={testId}
			data-hi-service-mode={state}
			style={{ marginBottom: compact ? 8 : 12 }}
		/>
	);
};

export default HiServiceModeNotice;
